"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _endpoints = require("../endpoints");
var _promiseCache = _interopRequireDefault(require("../utils/promise-cache"));
var _fetchWithAuth = _interopRequireDefault(require("../utils/fetch-with-auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RecognitionService(authState) {
  const fetch = new _fetchWithAuth.default(authState);
  const cache = new _promiseCache.default(authState);
  async function searchRewardChoices(filters = {}) {
    return await cache('searchRewardChoices', async () => {
      const res = await fetch(`${_endpoints.recognitionURL}/reward-choices/search`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(filters)
      });
      const {
        rewardChoices
      } = await res.json();
      return rewardChoices;
    })();
  }
  return {
    searchRewardChoices
  };
}
var _default = exports.default = RecognitionService;
//# sourceMappingURL=recognition.js.map